import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBell: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-1-stroke-1.5-IconBell"><Path d="M12 2C7.79219 2 4.26147 5.17264 3.8132 9.35647L3.19212 15.5761C3.08925 16.6062 3.89822 17.5 4.93346 17.5H19.0665C20.1018 17.5 20.9107 16.6062 20.8079 15.5761L20.1867 9.35648C19.7385 5.17264 16.2078 2 12 2Z" fill="currentColor"/><Path d="M16.5839 19H7.41602C8.18757 20.7659 9.94965 22 12 22C14.0503 22 15.8124 20.7659 16.5839 19Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBell;
